import { motion } from "framer-motion";
import { Users, Check } from "lucide-react";
import { ROOMS, HOTEL } from "../../data/content";

export const Rooms = () => {
  return (
    <section
      id="stays"
      data-testid="rooms-section"
      className="relative bg-forest-900 py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-16">
          <p className="text-xs tracking-[0.25em] uppercase text-earth-400 font-semibold mb-5">
            Accommodations
          </p>
          <h2 className="font-serif font-light text-sand-100 text-3xl sm:text-5xl leading-tight text-balance">
            Wooden lodges, woven into the forest
          </h2>
          <p className="text-sand-200/80 text-base sm:text-lg leading-relaxed mt-5">
            Each room is built from local timber and open to the breeze —
            designed to bring you closer to nature without leaving comfort behind.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {ROOMS.map((room, i) => (
            <motion.article
              key={room.id}
              data-testid={`room-card-${room.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group flex flex-col overflow-hidden rounded-3xl bg-forest-800 border border-sand-100/10"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={room.image}
                  alt={room.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-sand-100/90 backdrop-blur px-3 py-1.5 text-xs font-semibold text-forest-900">
                  <Users size={13} /> {room.capacity}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-7">
                <h3 className="font-serif text-2xl text-sand-100 mb-3">
                  {room.name}
                </h3>
                <p className="text-sand-200/75 text-sm leading-relaxed mb-6">
                  {room.desc}
                </p>
                <ul className="space-y-2.5 mb-7 mt-auto">
                  {room.features.map((f) => (
                    <li
                      key={f}
                      className="flex items-center gap-2.5 text-sm text-sand-200/85"
                    >
                      <Check size={15} className="text-earth-400 shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  data-testid={`room-enquire-${room.id}`}
                  className="inline-flex items-center justify-center rounded-full border border-earth-400/60 text-earth-400 hover:bg-earth-500 hover:text-white hover:border-earth-500 px-6 py-3 text-sm font-semibold transition-colors duration-300"
                >
                  Enquire about this stay
                </a>
              </div>
            </motion.article>
          ))}
        </div>

        <p className="text-center text-sand-200/60 text-sm mt-12">
          Rates vary by season. Message us on{" "}
          <a
            href={`https://wa.me/${HOTEL.phoneDigits}`}
            target="_blank"
            rel="noreferrer"
            className="text-earth-400 underline underline-offset-4 hover:text-earth-500"
            data-testid="rooms-whatsapp-link"
          >
            WhatsApp
          </a>{" "}
          for availability and tailored packages.
        </p>
      </div>
    </section>
  );
};
